// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "bfca7c8a85220aa9e57952bc133fe00f" + ".js";
};